import PopularQuizBanner from './PopularQuizBanner';
export default PopularQuizBanner;